/**
 * The NewMatchDetailHome class acts as the view object for the new match detail home page.
 */
const Address = require('@/tbs/model/mo/Address')
const NewMatchDetail = require('@/tbs/model/to/NewMatchDetail')
const DateTimeFunc = require('@/fcl/tbs/util/DateTimeFunc')

const locale = new NewMatchDetail
const tbs_model_vo_NewMatchDetailHome = function () {
}

//--------------------------------------------------
// prototype
//--------------------------------------------------
tbs_model_vo_NewMatchDetailHome.prototype = {
  /* The view object name */
  name: '',
  /* The view object instance */
  view: {
    get: [
      {
        name: '',
        baseUrl: process.env.VUE_APP_BANMA_API,
        apiPrefix: '/bmmatch/',
        service: 'GetBMUnionMatch',
        query: {
          unionMatchId: 'unionMatchId',
          sportType: 'sportType',
          preview: '(0)'
        },
        basePath: 'data.match',
        rule: {
          componentList: '$sportType,regBeginDate,regEndDate,regUpdateEndDate,beginDate,endDate'
        }
      },
      {
        name: 'componentData',
        baseUrl: process.env.VUE_APP_BANMA_API,
        apiPrefix: '/bmmatch/',
        service: 'GetBMUnionMatchRankResult',
        query: {
          unionMatchId: 'unionMatchId'
        },
        basePath: 'data',
        rule: {
          ScoreAnnouncement: '$matchList'
        }
      },
      // 近期比赛：接口返回 data.list，经 renderRecentGames 后写入 componentData.RecentGames
      {
        name: 'componentData',
        baseUrl: process.env.VUE_APP_BANMA_API,
        apiPrefix: '/bmmatch/',
        service: 'GetBMUnionMatchRecentGameList',
        query: {
          unionMatchId: 'unionMatchId',
          pageSize: '(4)'
        },
        basePath: 'data',
        rule: {
          RecentGames: '$list'
        }
      },
      {
        name: 'componentData',
        baseUrl: process.env.VUE_APP_BANMA_API,
        apiPrefix: '/bmmatch/',
        service: 'GetCrmNewsList',
        query: {
          unionMatchId: 'unionMatchId',
          accountId: '^0.data.payload.data.match.accountId',  // use the object path for the variable value
          pageSize: '(4)'
        },
        basePath: 'data',
        rule: {
          NewsAnnouncement: '$list'
        },
        seq: true,    // use the seq flag with true for the flow request
      },
      {
        name: 'componentData',
        baseUrl: process.env.VUE_APP_BANMA_API,
        apiPrefix: '/bmmatch/',
        service: 'GetBMUnionMatch',
        query: {
          unionMatchId: 'unionMatchId',
          preview: '(0)'
        },
        basePath: 'data',
        rule: {
          BasicInfo: '$match'
        }
      },
      {
        name: 'componentData',
        baseUrl: process.env.VUE_APP_BANMA_API,
        apiPrefix: '/bmmatch/',
        service: 'GetBMUnionMatch',
        query: {
          unionMatchId: 'unionMatchId',
          preview: '(0)'
        },
        basePath: 'data',
        rule: {
          Regulations: '$match'
        }
      },
      {
        name: 'componentData',
        baseUrl: process.env.VUE_APP_BANMA_API,
        apiPrefix: '/bmmatch/',
        service: 'GetBMMatchList2',
        query: {
          unionMatchId: 'unionMatchId'
        },
        basePath: 'data',
        rule: {
          Registration: '$list'
        }
      },
      {
        name: 'componentData',
        baseUrl: process.env.VUE_APP_BANMA_API,
        apiPrefix: '/bmmatch/',
        service: 'GetUnionMatchShortcutList',
        query: {
          unionMatchId: 'unionMatchId'
        },
        basePath: 'data',
        rule: {
          Tabs: '$list'
        }
      }
    ],
  },
  //--------------------------------------------------
  // render methods
  //--------------------------------------------------
  /**
   * 根据运动类型生成组件配置列表
   * @param {String} sportType - 运动类型
   * @returns {Array} 组件配置列表
   */
  renderComponentList: function (sportType, regBeginDate, regEndDate, regUpdateEndDate, beginDate, endDate) {
    if (!sportType) {
      return []
    }

    const componentConfigs = {
      // '足球': this.getFootballComponents(),
    }

    return componentConfigs[sportType] || this.getDefaultComponents(
      regBeginDate,
      regEndDate,
      regUpdateEndDate,
      beginDate,
      endDate
    )
  },

  /**
   * 赛事首页区块顺序（默认）
   * 阶段划分：
   * - A 筹备/报名/名单调整：当前时间 ≤ 名单调整结束（无名单调整结束时间则用报名结束时间）；且无报名时间时不含「赛事报名」
   * - B 名单调整后～比赛结束：在 A 之后且未过比赛结束时间
   * - C 已结束：当前时间 > 比赛结束时间
   * 赛事集锦、数据总结等尚未接入的区块在排序中省略（有则可在对应阶段数组中补全 component 名）
   */
  getDefaultComponents: function (regBeginDate, regEndDate, regUpdateEndDate, beginDate, endDate) {
    const registration = {
      name: locale.localeProp('registration'),
      id: 'registration',
      component: 'Registration',
      emptyDataShow: false
    }
    const regulationsItem = {
      name: locale.localeProp('regulations'),
      id: 'regulations',
      component: 'Regulations',
      emptyDataShow: false
    }
    const scoreAnnouncement = {
      name: locale.localeProp('score-announcement'),
      id: 'score-announcement',
      component: 'ScoreAnnouncement',
      emptyDataShow: false
    }
    const recentGames = {
      name: '热门赛程',
      id: 'recent-games',
      component: 'RecentGames',
      emptyDataShow: false,
      router: '/match-detail/${unionMatchId}/schedule',
    }
    const basicInfo = {
      name: locale.localeProp('basic-info'),
      id: 'basic-info',
      component: 'BasicInfo',
      emptyDataShow: false
    }
    const newsAnnouncement = {
      name: '最新资讯',
      id: 'news-announcement',
      component: 'NewsAnnouncement',
      emptyDataShow: false,
      router: '/match-detail/${unionMatchId}/news',
    }
    const tabs = {
      name: '',
      id: 'tabs',
      component: 'Tabs',
      emptyDataShow: false
    }

    const byComponent = {
      Tabs: tabs,
      Registration: registration,
      Regulations: regulationsItem,
      BasicInfo: basicInfo,
      NewsAnnouncement: newsAnnouncement,
      RecentGames: recentGames,
      ScoreAnnouncement: scoreAnnouncement
    }

    const hasRegTime = !!(regBeginDate && regEndDate)

    const parseTs = function (d) {
      if (!d) return NaN
      const t = new Date(d).getTime()
      return isNaN(t) ? NaN : t
    }

    const now = Date.now()
    const regEndTs = parseTs(regEndDate)
    const regUpdateEndTs = parseTs(regUpdateEndDate)
    const adjEndTs = hasRegTime
      ? (isFinite(regUpdateEndTs) ? regUpdateEndTs : regEndTs)
      : NaN

    const endTs = parseTs(endDate)

    const phaseA = hasRegTime && isFinite(adjEndTs) && now <= adjEndTs
    const phaseC = isFinite(endTs) && now > endTs
    // const phaseB = !phaseA && !phaseC

    // 规格顺序中含「赛事集锦/数据总结」等时在此处追加 component 名即可
    const orderA = [
      'Tabs',
      'Registration',
      'Regulations',
      'BasicInfo',
      'NewsAnnouncement',
      'RecentGames',
      'ScoreAnnouncement'
    ]
    const orderB = [
      'Tabs',
      'RecentGames',
      'NewsAnnouncement',
      'ScoreAnnouncement',
      'Registration',
      'Regulations',
      'BasicInfo',
    ]
    const orderC = [
      'Tabs',
      'ScoreAnnouncement',
      'RecentGames',
      'NewsAnnouncement',
      'Registration',
      'Regulations',
      'BasicInfo',
    ]

    let orderNames = phaseA ? orderA : (phaseC ? orderC : orderB)

    const list = []
    for (let i = 0; i < orderNames.length; i++) {
      const key = orderNames[i]
      if (key === 'Registration' && !hasRegTime) continue
      const item = byComponent[key]
      if (item) list.push(item)
    }
    return list
  },
  /**
   * 成绩公告：将 matchList 处理成一维数组
   * 单组别：取该组按 finalRank 排序的前三；多组别：取每组第一名
   */
  renderScoreAnnouncement: function (matchList) {
    if (!matchList || !Array.isArray(matchList)) return []
    var list = (Array.isArray(matchList[0]) && matchList[0].length > 0) ? [].concat.apply([], matchList) : matchList
    var toItem = function (match, t) {
      return {
        chineseName: match.chineseName || '',
        group: match.group || '',
        id: match.id || '',
        badge: t.badge,
        finalRank: t.finalRank,
        teamId: t.id,
        matchId: t.matchId,
        name: t.name,
        loseRound: t.loseRound,
        tieRound: t.tieRound,
        winRound: t.winRound
      }
    }
    return list.reduce(function (acc, match) {
      if (!match || !Array.isArray(match.teams)) return acc
      var teams = match.teams.slice().sort(function (a, b) {
        return (a.finalRank != null ? Number(a.finalRank) : 999) - (b.finalRank != null ? Number(b.finalRank) : 999)
      })
      var take = list.length === 1 ? teams.slice(0, 3) : teams.slice(0, 1)
      take.forEach(function (t) { acc.push(toItem(match, t)) })
      return acc
    }, [])
  },
  /**
   * 格式化近期比赛列表，供 componentData.RecentGames 使用
   * 规则 RecentGames: '$list' 会传入 data.list 并调用本方法
   */
  renderRecentGames: function (list) {
    if (!list || !Array.isArray(list)) {
      return []
    }
    const self = this
    return list.map(function (item) {
      return self.formatRecentGameItem(item)
    })
  },

  formatRecentGameItem: function (item) {
    if (!item) return {}
    return {
      id: item.id,
      name: item.name || item.roundName,
      home: {
        name: item.homeAlias || item.homeName || locale.localeProp('team-name-default'),
        logUrl: item.homeBadge || item.matchIcon,
        homeTeamId: item.homeTeamId || '',
        score: item.homeScore === -1 || item.homeScore == null ? '' : item.homeScore,
      },
      away: {
        name: item.awayAlias || item.awayName || locale.localeProp('team-name-default'),
        logUrl: item.awayBadge || item.matchIcon,
        awayTeamId: item.awayTeamId || '',
        score: item.awayScore === -1 || item.awayScore == null ? '' : item.awayScore,
      },
      time: item.beginDate ? DateTimeFunc.formatDate(new Date(item.beginDate), 'MM.dd hh:mm') : '',
      status: this.renderStatus(item.liveRoomStatus, item.liveStatus),
      statusLabel: this.renderStatusLabel(item.liveStatus),
      type: item.type,
      gameMode: item.gameMode,
      group: item.group
    }
  },
  renderStatus: function (liveRoomStatus, liveStatus) {
    if (liveRoomStatus === -1) { // 未开通直播
      return -1
    } else return liveStatus // 0未直播 1直播中 2回看
  },
  renderStatusLabel: function (liveStatus) {
    if (liveStatus === -1) {
      return ''
    } else return locale.localeProp('live-status-label-' + liveStatus)
  },
  renderNewsAnnouncement: function (list) {
    if (!list || !Array.isArray(list)) {
      return []
    }
    return list.map(item => {
      return {
        id: item.id,
        title: item.title,
        sourceUrl: item.sourceUrl || '',
        publishDate: DateTimeFunc.formatDate(new Date(item.publishDate), 'MM/dd') || '',
      }
    })
  },
  renderBasicInfo: function (match) {
    if (!match) return {}
    return {
      id: match.id,
      beginDate: DateTimeFunc.formatDate(new Date(match.beginDate), 'yyyy-MM-dd') || '',
      endDate: DateTimeFunc.formatDate(new Date(match.endDate), 'yyyy-MM-dd') || '',
      city: Address.renderAddress(match.province, match.city, match.district, '') || '',
      location: match.location || '',
      units: this.renderUnits(match.supervisor, match.endorser, match.contactor, match.coorganizer) || '',
      regBeginDate: match.regBeginDate || '',
      regEndDate: match.regEndDate || '',
    }
  },
  renderUnits: function (supervisor, endorser, contactor, coorganizer) {
    const units = []
    if (supervisor) {
      units.push({
        name: locale.localeProp('supervisor'),
        value: supervisor.replace(/｜/g, '|').replace(/,/g, '、'),
      })
    }
    if (endorser) {
      units.push({
        name: locale.localeProp('endorser'),
        value: endorser.replace(/｜/g, '|').replace(/,/g, '、'),
      })
    }
    if (contactor) {
      units.push({
        name: locale.localeProp('contactor'),
        value: contactor.replace(/｜/g, '|').replace(/,/g, '、'),
      })
    }
    if (coorganizer) {
      units.push({
        name: locale.localeProp('coorganizer'),
        value: coorganizer.replace(/｜/g, '|').replace(/,/g, '、'),
      })
    }
    return units
  },
  renderRegulations: function (match) {
    if (!match) return {}
    return match.regulations || ''
  },
  renderRegistration: function (list, options, transformedCollection) {
    // try to use the appendix parameters for the extended data source
    // use the options for the current context one
    // use the transformedCollection for the whole caller one
    if (!list || !Array.isArray(list)) {
      return { groupsName: '', price: '' }
    }
    const groupsName = list.map(function (item) { return item.group }).join('、')
    const price = this._formatRegistrationPrice(list)
    // transformedCollection 中寻找 BasicInfo, 获取regBeginDate和regEndDate
    let regBeginDate = ''
    let regEndDate = ''
    let unionMatchId = ''
    transformedCollection.forEach(item => {
      if (item['BasicInfo']) {
        regBeginDate = item['BasicInfo'].regBeginDate
        regEndDate = item['BasicInfo'].regEndDate
        unionMatchId = item['BasicInfo'].id
      }
    })
    return {
      groupsName,
      price,
      regBeginDate,
      regEndDate,
      unionMatchId
    }
  },
  /**
   * 金刚位：由 GetUnionMatchShortcutList 返回已启用入口。
   * native 类型 url 使用字面量「/match-detail/${unionMatchId}/xxx」，
   * 点击时在 Tabs 组件内用当前路由的 unionMatchId 替换占位符。
   */
  renderTabs: function (list) {
    if (!list || !Array.isArray(list)) {
      return []
    }
    return list.map(function (item) {
      return {
        name: item.name || '',
        type: item.type || 'native',
        icon: item.icon || '',
        url: item.url || ''
      }
    }).filter(function (item) {
      return item.name && item.url
    })
  },
  /**
   * 计算报名最低价文案：0元/队 起、1元/人 起 等
   * feeMethod: 0不付费 1队员付款 2领队付款 3领队付款(按人数)
   * unitType: 0队伍 1个人 2多人
   * openFeeMin: 0关 1开；feeMinAmount: 领队按人数时的最低金额(分)
   */
  _formatRegistrationPrice: function (list) {
    if (!list || list.length === 0) return ''
    var getUnitText = function (unitType) {
      if (unitType === 0) return '队'
      if (unitType === 1) return '人'
      return '人'
    }
    var getAmountFen = function (item) {
      var feeMethod = item.feeMethod
      var unitType = item.unitType
      if (feeMethod === 0) {
        return { amountFen: 0, unit: getUnitText(unitType) }
      }
      if (feeMethod === 1) {
        return { amountFen: item.feeAmount != null ? Number(item.feeAmount) : 0, unit: '人' }
      }
      if (feeMethod === 2) {
        return { amountFen: item.feeAmount != null ? Number(item.feeAmount) : 0, unit: '队' }
      }
      if (feeMethod === 3) {
        var openFeeMin = item.openFeeMin
        var amountFen = (openFeeMin === 1 && item.feeMinAmount != null)
          ? Number(item.feeMinAmount)
          : (item.feeAmount != null ? Number(item.feeAmount) : 0)
        return { amountFen: amountFen, unit: '人' }
      }
      return { amountFen: 0, unit: getUnitText(unitType) }
    }
    var amounts = []
    for (var i = 0; i < list.length; i++) {
      amounts.push(getAmountFen(list[i]))
    }
    var allFree = amounts.every(function (a) { return a.amountFen === 0 })
    if (allFree) {
      return '免费'
    }
    var minAmount = null
    var minUnit = amounts[0].unit
    for (var j = 0; j < amounts.length; j++) {
      if (minAmount === null || amounts[j].amountFen < minAmount) {
        minAmount = amounts[j].amountFen
        minUnit = amounts[j].unit
      }
    }
    var yuan = (minAmount / 100).toFixed(0)
    return yuan + '元/' + minUnit + ' 起'
  }
}

module.exports = tbs_model_vo_NewMatchDetailHome
